<div class="container-wrapper proformbuilder">
  <div class="container">
    <div class="py-4 main-wrapper">
      <ng-container
        *ngIf="form && form.type === proFormType.QUIZ; else loadingTemplate">
        <div class="content-wrapper">
          <div class="content">
            <div
              class="d-flex flex-column flex-md-row justify-content-between align-items-center pb-5 item-content">
              <div class="me-4">
                <div class="fs-22 fw-bold">Help</div>
                <p>
                  Use this page to create a quiz that helps participants reflect
                  on what they've learned. You can include questions to assess
                  understanding, prompts for reflection, or allow file uploads
                  for submitted work. Radio and Checkbox question types can be
                  automatically graded.
                </p>
              </div>
              <button
                type="button"
                class="btn btn-primary btn-preview fw-bold"
                (click)="previewModal.openModal()">
                <i class="bi bi-eye me-2"></i> Preview
              </button>
            </div>

            <div class="item-content">
              @if(form.sections) { @for(section of form.sections; track
              section?.id; let i = $index) {
              <!-- SECTION INDICATOR -->
              <!-- <div class="section-card">
                <div class="section-header">
                  Section {{ i + 1 }} of {{ form.sections.length }}
                </div>
                <div class="section-body">
                  <div class="title">{{ section.title }}</div>
                  <p>{{ section.description }}</p>
                </div>
              </div> -->
              @if(section.questions.length === 0) {
              <div class="outer-wrapper">
                <div class="form-item-wrapper static">
                  <button
                    class="btn-reset item item-question"
                    (click)="createQuestion(section.id)">
                    <div class="item-icon">Q</div>
                    <div class="item-label">Question</div>
                  </button>
                </div>
              </div>
              } @if(section.questions && section.questions.length > 0) {
              @for(question of section.questions; track question?.id) {
              <app-proforms-admin-question [question]="question" />
              } } } }
            </div>

            <div class="card outro-card mt-5" [class.focused]="isEditingOutro">
              <div
                class="card-header outro-card-header fs-6 d-flex justify-content-between">
                Outro
                <i
                  class="bi bi-info-circle-fill"
                  ngbTooltip="The outro is where you can write a confirmation message or next steps. Respondents will see this message once they submit the form."
                  containerClass="outro-card-tooltip"></i>
              </div>
              <div #outroBody>
                <ng-container *ngIf="isEditingOutro; else previewOutro">
                  <div class="card-body outro-card-body">
                    <app-ck-editor
                      [version]="'full'"
                      [minHeight]="'150px'"
                      [initialData]="form.outro"
                      (contentChange)="updateOutro($event)">
                    </app-ck-editor>
                  </div>
                </ng-container>
                <ng-template #previewOutro>
                  <div
                    (click)="showEditOutro($event)"
                    class="card-body outro-card-body position-relative pointer p-5">
                    <i class="bi bi-pencil color-tertiary edit-icon"></i>
                    <app-safehtml [html]="form.outro"></app-safehtml>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="sidebar">
          <div class="sidebar-body px-5 py-3 py-lg-5">
            <div class="form-group mb-3">
              <div class="mb-4">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label fw-400 my-0" for="passing-grade"
                    >Passing Grade (0-100)</label
                  >
                  <input
                    [formControl]="passingGradeControl"
                    type="number"
                    class="form-control text-center"
                    id="passing-grade"
                    style="max-width: 80px"
                    aria-label="Passing Grade (0-100)"
                    [ngClass]="{
                      'is-invalid': passingGradeControl.errors
                    }" />
                </div>
                <div
                  *ngIf="passingGradeControl.errors"
                  class="text-danger small">
                  <div *ngIf="passingGradeControl.errors?.['required']">
                    Required for quizzes.
                  </div>
                  <div
                    *ngIf="passingGradeControl.errors?.['min'] || passingGradeControl.errors?.['max']">
                    Must be between 0-100.
                  </div>
                  <div *ngIf="passingGradeControl.errors?.['notWholeNumber']">
                    Must be a whole number.
                  </div>
                </div>
              </div>
              <p class="fw-bold mb-1">After submission,</p>
              <div
                class="d-flex align-items-center justify-content-between mb-3">
                <label
                  class="form-label fw-normal my-0"
                  for="show-missed-questions"
                  >Show missed questions</label
                >
                <button
                  aria-label="Show missed questions"
                  class="form-switch btn-reset">
                  <input
                    class="form-check-input cursor-pointer"
                    type="checkbox"
                    role="switch"
                    id="show-missed-questions"
                    [checked]="form.show_missed === 1"
                    (change)="updateShowMissed($event)" />
                </button>
              </div>
              <div
                class="d-flex align-items-start justify-content-between mb-5">
                <label
                  class="form-label fw-normal my-0"
                  [ngClass]="{
                    'text-muted': form.show_missed !== 1
                  }"
                  for="show-correct-answers"
                  >Show correct answers to missed questions</label
                >
                <button
                  [disabled]="form.show_missed !== 1"
                  aria-label="Show correct answers to missed questions"
                  class="form-switch btn-reset">
                  <input
                    [disabled]="form.show_missed !== 1"
                    [ngClass]="{
                      'cursor-pointer': form.show_missed === 1
                    }"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="show-correct-answers"
                    [checked]="form.show_answers === 1"
                    (change)="updateShowAnswers($event)" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <app-proform-preview-modal #previewModal [formId]="formId" />
      </ng-container>
      <ng-template #loadingTemplate>
        <div
          class="w-100 position-relative"
          style="background-color: #fff; height: 500px">
          <app-loader></app-loader>
        </div>
      </ng-template>
    </div>
  </div>
</div>
